import React from "react";
import {
  Users,
  CheckCircle2,
  Clock3,
  AlertTriangle,
  Ban,
  IndianRupee,
  TrendingUp,
  Wallet
} from "lucide-react";

import "./MetricsGrid.css";

export default function MetricsGrid({
  subscriptions,
  filterView,
  setFilterView
}) {

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const next30Days = new Date(today);
  next30Days.setDate(today.getDate() + 30);

  const stats = subscriptions.reduce((acc, sub) => {

    const expiry = new Date(sub.expiryDate);
    expiry.setHours(0, 0, 0, 0);

    acc.total++;

    acc.totalSelling += Number(sub.sellingRate || 0);
    acc.totalRenewal += Number(sub.renewalRate || 0);

    if (sub.isSuspended) {

      acc.suspended++;
      return acc;

    }

    if (expiry < today) {

      acc.expired++;

    } else if (expiry <= next30Days) {

      acc.expiringSoon++;

    } else {

      acc.active++;

    }

    return acc;

  }, {

    total: 0,
    active: 0,
    expired: 0,
    expiringSoon: 0,
    suspended: 0,
    totalSelling: 0,
    totalRenewal: 0

  });

  const healthyPercentage =
    stats.total === 0
      ? 0
      : Math.round((stats.active / stats.total) * 100);

  const cards = [

    {
      id: "all",
      title: "Total Clients",
      subtitle: "Registered subscriptions",
      value: stats.total,
      color: "primary",
      icon: <Users size={24} />
    },

    {
      id: "active",
      title: "Active",
      subtitle: "Currently running",
      value: stats.active,
      color: "success",
      icon: <CheckCircle2 size={24} />
    },

    {
      id: "expiringSoon",
      title: "Expiring Soon",
      subtitle: "Within next 30 days",
      value: stats.expiringSoon,
      color: "warning",
      icon: <Clock3 size={24} />
    },

    {
      id: "expired",
      title: "Expired",
      subtitle: "Immediate renewal required",
      value: stats.expired,
      color: "danger",
      icon: <AlertTriangle size={24} />
    },

    {
      id: "suspended",
      title: "Suspended",
      subtitle: "Currently blocked",
      value: stats.suspended,
      color: "secondary",
      icon: <Ban size={24} />
    }

  ];

  return (

    <div className="dashboard-metrics fade-in">

      <div className="metrics-grid">

        {

          cards.map(card => (

            <div

              key={card.id}

              className={`
                metric-card
                ${card.color}
                ${filterView === card.id ? "active-card" : ""}
              `}

              onClick={() => setFilterView(card.id)}

            >

              <div className="metric-top">

                <div className={`metric-icon ${card.color}`}>

                  {card.icon}

                </div>

                <div className="metric-menu">

                  •••

                </div>

              </div>

              <div className="metric-number">

                {card.value.toLocaleString("en-IN")}

              </div>

              <div className="metric-title">

                {card.title}

              </div>

              <div className="metric-subtitle">

                {card.subtitle}

              </div>

              <div className="metric-footer">

                <span>

                  Click to filter

                </span>

                <TrendingUp size={16} />

              </div>

            </div>

          ))

        }

      </div>

      <div className="business-summary">

        <div className="summary-card revenue">

          <div className="summary-icon">

            <IndianRupee size={24} />

          </div>

          <div className="summary-content">

            <div className="summary-label">

              Total Selling Value

            </div>

            <div className="summary-amount">

              ₹ {stats.totalSelling.toLocaleString("en-IN")}

            </div>

            <div className="summary-desc">

              Revenue generated from activations

            </div>

          </div>

        </div>

        <div className="summary-card renewal">

          <div className="summary-icon">

            <Wallet size={24} />
          </div>

          <div className="summary-content">

            <div className="summary-label">
              Renewal Portfolio
            </div>

            <div className="summary-amount">
              ₹ {stats.totalRenewal.toLocaleString("en-IN")}
            </div>

            <div className="summary-desc">
              Expected renewal revenue
            </div>

          </div>

        </div>

        <div className="summary-card health">

          <div className="summary-icon">

            <TrendingUp size={24} />

          </div>

          <div className="summary-content">

            <div className="summary-label">

              Subscription Health

            </div>

            <div className="summary-amount">

              {healthyPercentage}%

            </div>

            <div className="summary-desc">

              Healthy active subscriptions

            </div>

            <div className="progress-bar">

              <div
                className="progress-fill"
                style={{
                  width: `${healthyPercentage}%`
                }}
              />

            </div>

          </div>

        </div>

      </div>

    </div>

  );

}